import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/35/thumb-landscape.jpg"

const Post35 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">Dior／サドルバッグ／23 x19 x6cm</span>  
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>1946年に創業した歴史あるブランドDIOR。世界的に有名なラグジュアリーブランドです。<br></br>これまで多くの実力者たちがデザイナーを歴任していますが、2016年からはマリア・グラツィア・ キウリが主任デザイナーに就任。DIORの長い歴史の中で、初めて女性が抜擢されました。<br></br>彼女のデザインは当てつけがましくない可愛らしさが魅力。持ってみたい！そんな気持ちにさせてくれます。<br></br>今回は、マリア・グラツィア・キウリが手掛けたバッグはもちろん、おしゃれセレブたちが愛用しているディオールの人気バッグをご紹介します！</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">        
        <div className="text-max-width">
          <h2>BOOK TOTEスモールバッグ</h2>
          <figure className="img-small">
            <StaticImage src="../../images/posts/35/1.png" alt="" />
            <span className="text-center">リラックス感のあるシンプルコーデのポイントに！</span>
          </figure>          
          <p>今やディオールを語る上ではずせないブックトート。マリア・グラツィア・キウリが手掛けた2018年春夏コレクションでデビューしました。<br></br>ブランドを象徴する「ディオール オブリーク」のキャンバス地を使用しています。キャンバス地ながら、ラグジュアリーブランドらしい存在感やしなやかな手触りは、最高級の素材や熟練の技術の賜物。<br></br>世界中のセレブがプライベートで愛用している姿を度々キャッチされています。<br></br>「スモールバッグ」といえど横幅もマチもたっぷりあり、PCや各種デバイス、A4サイズの書類も入りそう！持つ人によって様々な使い方が可能です。</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/35/2.jpg" alt="" />
            <span className="text-center">35x25x15cm</span>
          </figure>          
        </div>        
        <div className="text-max-width">
          <h2>LADY DIOR</h2>
          <figure className="img-small">
            <StaticImage src="../../images/posts/35/3.png" alt="" />
            <span className="text-center">大人の女性にこそ持って欲しい上品さ</span>
          </figure>
          <p>ディオールの王道アイコンバッグといえばコチラ！エレガントな雰囲気漂う、気品あるバッグです。<br></br>ハンドルには独立した形でD・I・O・Rの4文字が、チャームとしてついています。歩くたびにゆらゆら揺れてとっても可愛い！トップハンドルと取り外しができるストラップの2WAYで使えます。<br></br>お仕事にはストラップを付けてアクティブに、レストランでの食事にはハンドルだけで上品に…と、オンオフ問わずに活躍しそう。</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/35/4.jpg" alt="" />
            <span className="text-center">31x24x11cm</span>
          </figure>
        </div>
        <Link to="https://laxus.co/app/pc/bags/dior" className="view-all-button">
          ディオールのバッグを見る
        </Link>
        <div className="text-max-width">
          <h2>SADDLE</h2>
          <figure className="img-small">
            <StaticImage src="../../images/posts/35/5.png" alt="" />
            <span className="text-center">たっぷりニットとレースの可愛らしい組み合わせに</span>
          </figure>
          <p>今から20年くらい前、2000年前後に流行したサドルバッグ。復刻版が発売され、多くのセレブから再び注目を浴びています。<br></br>この独特なフォルムに「コーデが難しそう」と思ったなら、それは思い違い！コンサバ、フェミニン、マニッシュ、モードなど、どんなスタイルにも合わせやすいのです。<br></br>例えカジュアルなコーデだったとしても、曲線的なフォルムが女性らしさを演出してくれます。</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/35/6.jpg" alt="" />
            <span className="text-center">18x16x5cm</span>
          </figure>
        </div>
        <div className="text-max-width">
          <h2>30 MONTAIGNE</h2>
          <figure className="img-small">
            <StaticImage src="../../images/posts/35/7.png" alt="" />
            <span className="text-center">コンサバに新アイコンバッグでスパイスを</span>
          </figure>
          <p>「30 モンテーニュ」という名は、ディオール発祥の地であり、現在も本店を構えるメゾンの象徴的な場所、パリのアヴェニュー モンテーニュ30番地を意味します。新アイコンバッグとの呼び声も高い注目株です。<br></br>上質なカーフレザーの端正なショルダーバッグのアクセントはフロントのブランドイニシャル。<br></br>ワンタッチでフラップを開け閉めできたり、背面にもポケットがあったりと使いやすさも◎</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/35/8.jpg" alt="" />
            <span className="text-center">24x17x16cm</span>
          </figure>
        </div>   
        <div className="text-two-cloumn">
          <h2>ディオールの魅力とは</h2>
          <p>革新的なデザインだったり、使い勝手が良かったり、ディオールのバッグには様々な側面があります。でも、結局のところ女性らしさを引き出してくれるのが一番の魅力かも。<br></br>お仕事でもプライベートでも、フェミニンでもカジュアルでも、ディオールのバッグを持てばエレガントな気品が漂うはずです！</p>
        </div>
        <Link to="https://laxus.co/app/pc/bags/dior" className="view-all-button">
          ディオールのバッグを見る
        </Link>        
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post35

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 35}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
